import { useEffect, useRef } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PawMark } from "@/components/PawMark";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then(({ data }) => {
        setUser(data);
        navigate("/account", { replace: true, state: { user: data } });
      })
      .catch(() => navigate("/account?signin=failed", { replace: true }));
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#1C1F1E] flex items-center justify-center" data-testid="auth-callback">
      <PawMark className="w-10 h-10 text-[#B5A642] animate-pulse" />
    </div>
  );
};
